import * as _ from 'lodash';
import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectOrgUser } from '../../features/dashboard.selectors';
import { filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-header-dashboard',
  templateUrl: './header-dashboard.component.html',
  styleUrls: ['./header-dashboard.component.scss']
})
export class HeaderDashboardComponent implements OnInit,OnDestroy  {
  destroyRef = inject(DestroyRef)
  public pledgeUrl = null;
  public orgQRCode = null;
  public orgUser$ = this.store.pipe(
    select(selectOrgUser),
    filter(user=>!_.isNull(user)),
  )
  public takeUntilSubject: Subject<any> = new Subject();
  public orgLogoUrl = '';

  constructor(
    private store: Store) { }

  ngOnInit(): void {
    this.orgUser$.pipe(
      takeUntilDestroyed(this.destroyRef)
      ).subscribe((user: any)=>{
      this.orgQRCode = this.createQRCode(user)
      this.pledgeUrl =  this.createUrl(user)
      this.orgLogoUrl = user.logoUrl || user.imageUrl || '';
    })
  }
  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

  createUrl(user){
    return user ? window.location.protocol + "//" + window.location.hostname + "/@" + user.handle : ''
  }

  createQRCode(user){
    return user ?
    `/api/qr_code?payee=${user.id}`:
    `images/qr_default.png`;
  }

  onDownloadQr(user){
    if(user) {
      var pledgeUrl = window.location.protocol + "//" + window.location.hostname + "/@" + user.handle
      window['orgMain'].setupQRDownload("org", user.id, pledgeUrl, user.handle)
    }
  }
}
